"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleLinkClicks = void 0;
function findLink(el) {
    if (!el || !("tagName" in el))
        return undefined;
    if (el.tagName === "A")
        return el;
    return findLink(el.parentElement);
}
function handleLinkClicks(f) {
    var handler = function (e) {
        if (e.button !== 0)
            return;
        if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey)
            return;
        if (e.defaultPrevented)
            return;
        var link = findLink(e.target);
        if (!link)
            return;
        var url = new URL(link.href);
        // External links including other procols like mailto
        if (url.origin !== location.origin)
            return;
        e.preventDefault();
        f(url);
    };
    document.addEventListener("click", handler);
    return function () { return document.removeEventListener("click", handler); };
}
exports.handleLinkClicks = handleLinkClicks;
//# sourceMappingURL=clicks.js.map